import React from 'react';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import { Divider, Flex, Popover, Text } from '@mantine/core';
import * as Unicons from '@iconscout/react-unicons';
import { Rater } from '../../../types/rater';

interface SummaryProps {
  data: Rater[];
  type?: 'rater' | 'expectation';
}

const Summary: React.FC<SummaryProps> = ({ data, type }) => {
  const sumScoreRater = data.reduce((sum, item) => sum + item.scoreRater, 0);
  if (type === 'expectation') return null;
  return (
    <>
      <Divider my={0} />
      <div className="summary-table-method">
        <div>
          <Flex direction="column">
            <p className="summary-table-method__title m-0">Realization Score</p>
            <Flex justify="space-around">
              <Flex flex={1}>
                <p className="summary-table-method__description m-0">
                  Total Score : <span>{sumScoreRater}</span>
                </p>
              </Flex>
              <Flex flex={1} gap={4} align={'center'}>
                <Popover width={200} position="bottom" withArrow shadow="md">
                  <Popover.Target>
                    <div className="summary-table-method__button_information">
                      <Unicons.UilInfoCircle size={20} />
                    </div>
                  </Popover.Target>
                  <Popover.Dropdown>
                    <Text size="xs" fw={700}>
                      Rating Score
                    </Text>
                    <Text size="xs">
                      Is the result of the total realization score divided by 5
                      aspects
                    </Text>
                  </Popover.Dropdown>
                </Popover>
                <p className="summary-table-method__description m-0">
                  Rating Score :{' '}
                  <b>{(sumScoreRater / data?.length).toFixed(2)}</b>
                </p>
              </Flex>
            </Flex>
          </Flex>
        </div>

        {/* <div>
        <Flex direction="column">
          <p className="summary-table-method__title">Notes</p>
          <Flex justify="flex-start">
            <Flex flex={1}>
              <p className="summary-table-method__description">Notes</p>
            </Flex>
          </Flex>
        </Flex>
      </div> */}
      </div>
    </>
  );
};

export default Summary;
